export default __webpack_public_path__ + "static/media/new_landing_kp.f30bf457.png";